<template>
  <div class="data-section">
    <v-data-table class="data-table" :headers="headers" :items="parkingList" :loading-text="loadingText" loader-height="2" :loading="loading" :items-per-page="-1" hide-default-footer :mobile-breakpoint="1160">
      <template v-slot:item.patientCpr="{ item }">
        <span>{{ item.patientCpr ? item.patientCpr : '--' }}</span>
      </template>
      <template v-slot:item.licensePlate="{ item }">
        <span>{{ item.licensePlate ? item.licensePlate : '--' }}</span>
      </template>
      <template v-slot:item.mobilePhone="{ item }">
        <span>{{ item.mobilePhone ? item.mobilePhone : '--' }}</span>
      </template>
      <template v-slot:item.referenceNumber="{ item }">
        <span>{{ item.referenceNumber ? item.referenceNumber : '--' }}</span>
      </template>
      <template v-slot:item.operationDate="{ item }">
        <DateTimeCellIso :date="item.operationDate" />
      </template>
      <template v-slot:item.startDateTime="{ item }">
        <DateTimeCellIso :date="item.startDateTime" />
      </template>
      <template v-slot:item.endDateTime="{ item }">
        <DateTimeCellIso :date="item.endDateTime" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import ImportsIcon from '@/components/settings/ImportsIcon';
  import DateTimeCell from '@/components/common/DateTimeCell';
  import DateCell from '@/components/common/DateCell';
  import DateTimeCellIso from '@/components/common/DateTimeCellIso.vue';

  export default {
    name: 'ParkingData',
    components: {DateTimeCellIso, DateCell, DateTimeCell, ImportsIcon},

    data: function () {
      return {
        loadingText: 'Loading... Please wait',
      };
    },

    mounted: function () {
      this.$emit('getParking');
    },

    computed: {
      headers: function() {
        return [
          {text: 'CPR-nummer', value: 'patientCpr', sortable: false},
          {text: 'Nummerplade', value: 'licensePlate', sortable: false},
          {text: 'Mobiltelefon', value: 'mobilePhone', sortable: false},
          {text: 'Referencenummer', value: 'referenceNumber', sortable: false},
          {text: 'Operationsdato', value: 'operationDate', sortable: false},
          {text: 'Start', value: 'startDateTime'},
          {text: 'Ende', value: 'endDateTime'},
        ]
      },
      loading: function () {
        return this.$store.state.parking.parkingLoading;
      },
      parkingList: function () {
        return this.$store.state.parking.parkingList;
      },
    },
  };
</script>
